import { useMemo } from 'react'
import * as Yup from 'yup'

export function useValidationSchema() {
  const validationSchema = useMemo(() => {
    return Yup.object().shape({
      __type: Yup.mixed().oneOf(['LogoFormValues']),
      logoName: Yup.string().required(),
      logoImageSource: Yup.string().required(),
    })
  }, [])

  return validationSchema
}
